import { randomstring } from "randomstring-js";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  uploadEncodedFile,
} from "NetworkCall";
import { INSTANCE_URL, itemCount, BASE_IMAGES_URL } from "Constants";

export const DASHBOARD_BADGE_ALL_USER_LIST = "DASHBOARD_BADGE_ALL_USER_LIST";
export const DASHBOARD_BADGE_USER_LIST = "DASHBOARD_BADGE_USER_LIST";
export const IS_BADGE_DESIGN_MODAL_OPEN = "IS_BADGE_DESIGN_MODAL_OPEN"; // Add | edit badge Modal
export const IS_GENERATE_BADGE_MODAL_OPEN = "IS_GENERATE_BADGE_MODAL_OPEN"; // Generate Modal
export const DASHBOARD_BADGE_DESIGN_ALL_LIST =
  "DASHBOARD_BADGE_DESIGN_ALL_LIST";
export const DASHBOARD_BADGE_DESIGN_LIST = "DASHBOARD_BADGE_DESIGN_LIST";
export const SELECTED_ELEMENT = "SELECTED_ELEMENT";
export const DASHBOARD_BADGE_JSON = "DASHBOARD_BADGE_JSON";
export const DASHBOARD_BADGE_EDITDATA = "DASHBOARD_BADGE_EDITDATA";
export const IS_PRINT_PREVIEW_MODAL_OPEN = "IS_PRINT_PREVIEW_MODAL_OPEN"; // Print preview Modal
export const LOGIN_USER_DETAILS = "LOGIN_USER_DETAILS"; // Use to get login user all deatils [designation and company name]
export const IMAGE_ELEMENT_MODAL = "IMAGE_ELEMENT_MODAL";

/* 
    All modals
*/
export function openBadgeDesignModal(open) {
  // Badge design modal
  return (dispatch) => {
    dispatch({ type: IS_BADGE_DESIGN_MODAL_OPEN, payload: open });
  };
}

export function openGenerateBadgeModal(open) {
  // Badge Generate modal
  return (dispatch) => {
    dispatch({ type: IS_GENERATE_BADGE_MODAL_OPEN, payload: open });
  };
}

export function togglePrintPreviewModal(open) {
  // Print preview modal
  return (dispatch) => {
    dispatch({ type: IS_PRINT_PREVIEW_MODAL_OPEN, payload: open });
  };
}

// Get all appuser list for badge
export function fetchAllUserList(session, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=1)AND(userwaitlistmode=0)`
  );

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?fields=appuserid,firstname,lastname,username,comesfrom,responses,usercategory&include_count=true&admin=1&filter=(${filter})&order=firstname ASC,createdon DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_BADGE_ALL_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

/* Get User list */
export function sortListUserByCategory(
  session,
  sort = "all",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  var sortQuery = `usercategory like %${sort}%`;

  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=1)AND(userwaitlistmode=0)` +
      (sort === "all" ? "" : `AND(${sortQuery})`)
  );

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?fields=appuserid,firstname,lastname,username,comesfrom,responses,usercategory&include_count=true&admin=1&filter=(${filter})&order=firstname ASC,createdon DESC&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_BADGE_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

/*  
  Search user by user name / first name / last name
  similar as adminDashboardaction function
*/

export function SearchUsersForGenerateBadge(
  session,
  sort = "all",
  searchKeyWord,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;

  let sortQuery = `usercategory like %${sort}%`;
  let searchQuery = `username like %${searchKeyWord}%`;

  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=1)AND(userwaitlistmode=0)` +
      (sort === "all"
        ? `AND(${searchQuery})`
        : `AND(${sortQuery}) AND(${searchQuery})`)
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?fields=appuserid,firstname,lastname,username,comesfrom,responses,usercategory&include_count=true&admin=1&filter=(${filter})&order=firstname ASC,createdon DESC&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_BADGE_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function searchUsersToGenerateBadgeLimited(session, search, callback) {
  let searchQuery = `(email like %${search}%)OR(username like %${search}%)`;
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=1)AND(userwaitlistmode=0)AND(${searchQuery})`
  );
  var offSetQuery = `limit=10`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&admin=1&fields=appuserid,username&filter=(${filter})&order=firstname ASC,createdon DESC&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_BADGE_USER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function blankBadgeUserList() {
  return (dispatch) => {
    dispatch({ type: DASHBOARD_BADGE_USER_LIST, payload: {} });
  };
}

export function setSelectedElement(data = {}) {
  return (dispatch) => {
    dispatch({ type: SELECTED_ELEMENT, payload: data });
  };
}

export function handleImageEleModal(obj = {}) {
  return (dispatch) => {
    dispatch({ type: IMAGE_ELEMENT_MODAL, payload: obj });
  };
}

/* 
Set json object draggable stops
*/
export function setbadgeJson(data) {
  return (dispatch) => {
    dispatch({ type: DASHBOARD_BADGE_JSON, payload: data });
  };
}

/*
  Fetch All Badge designer list [Reducers name - dashboardAllBadgeList]
*/
export function fetchAllBadgeList(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template?include_count=true&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_BADGE_DESIGN_ALL_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          status: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

/*
  Fetch Badge designer list [Reducers name - DashboardBadgeList]
*/
export function fetchBadgeList(
  session,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template?include_count=true&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_BADGE_DESIGN_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

/*
  Fetch Badge designer list With search [Reducers name - ]
*/
export function searchBadge(
  session,
  search = "",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;
  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;
  let searchQuery = `badgename like '%25${search}%25'`;
  var filter = encodeURI(`(eventid=${session.eventid})AND(${searchQuery})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template?include_count=true&filter=(${filter})&${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: DASHBOARD_BADGE_DESIGN_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

/*
  add basge template
*/

export function addTemplate(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template`;

  let eventid = session.eventid;
  // var values = { eventid, templateid: selectedTemId };
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, message: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

/*
Set this single badge data to store [here true is for set and 'false' for remove]
*/

export function getSingleBadgerecord(data = {}, param) {
  if (param) {
    return (dispatch) => {
      dispatch({ type: DASHBOARD_BADGE_EDITDATA, payload: data }); // SET DATA FOR EDIT
      dispatch({
        // SET DATA FOR JSON
        type: DASHBOARD_BADGE_JSON,
        payload: JSON.parse(data.template),
      });
    };
  } else {
    // REMOVE RECORDS AND VALUES
    return (dispatch) => {
      dispatch({ type: DASHBOARD_BADGE_EDITDATA, payload: {} });
      dispatch({
        // RESET DATA FOR JSON
        type: DASHBOARD_BADGE_JSON,
        payload: [],
      });
    };
  }
}

/*
  Badge template update with id [patch]
*/
export function updateTemplate(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template`;
  let body = { resource: values };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, response: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

/*
  Delete badge with ID
*/
export function deleteTemplate(session, badgeid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template/${badgeid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, response: data });
      },
      (error) => {
        callback({ success: 0, response: error });
      }
    );
  };
}

/*
  Generate pdf for badge
*/
export function generateBadges(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/badge_design`;

  values = { ...values };
  // values = { ...values, eventid: parseInt(session.eventid) };

  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        // console.log("response", response);

        if (response.success) {
          callback({ ...response });
        } else {
          callback({ success: 0, message: response.message });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

/* Get login user details [Like - Company name and designation] */
export function getLogedinUserDeatils(session, callback) {
  let url = `${INSTANCE_URL}/api/v2/badge_design`;

  let body = {
    eventid: session.eventid,
    userid: session.userid,
    requesttype: "logedinUserDeatils",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: LOGIN_USER_DETAILS,
          payload: response?.data[0],
        });
        callback({ success: 1, message: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function uploadImages(session, file, callback) {
  var eventid = session.eventid;
  file = file.imagefile.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/badges/${randomstring(32)}.jpg`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: file,
      },
    ],
  };

  return (dispatch) => {
    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

/*
  Badge template update with id [patch]
*/
export function markDefault(session, values, callback) {
  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template?filter=${filter}`;
  let body = { resource: { isdefault: 0 } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        let url = `${INSTANCE_URL}/api/v2/eventify/_table/badge_template`;
        let body = {
          resource: {
            badgeid: values.badgeid,
            eventid: values.eventid,
            isdefault: 1,
          },
        };
        patchRequest(
          url,
          body,
          session,
          dispatch,
          (response) => {
            callback({ success: 1, response: response });
          },
          (error) => {
            callback({ success: 0, error: error });
          }
        );
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}
